module.exports = require("core-js/library/fn/array/splice");